import { render, staticRenderFns } from "./SpecialistDoctor.vue?vue&type=template&id=66ab820c&"
import script from "./SpecialistDoctor.vue?vue&type=script&lang=js&"
export * from "./SpecialistDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports